module.exports = __webpack_public_path__ + "img/logo.9319afa7.png";